//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'ScheduleControls',

  data() {
    return {
      openGroupId: null,
      drawerOpen: false,
    };
  },

  computed: {
    ...mapGetters(['filters']),

    filterGroups() {
      if (!this.filters || !this.filters.length) return [];
      const ORDER = ['session_format', 'session_topics', 'session_credit_type'];
      return ORDER.map(id => this.filters.find(g => g.id === id)).filter(Boolean);
    },
  },

  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.onDrawerKeydown);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.onDrawerKeydown);
  },

  methods: {
    onClear(setQuery, executeSearch) {
      setQuery({ target: { value: '' } });
      executeSearch();
    },

    activeCount(group) {
      if (!group.filters) return 0;
      return group.filters.filter(f => f.selected).length;
    },

    triggerLabel(group) {
      return group.name;
    },

    toggleGroup(groupId) {
      this.openGroupId = this.openGroupId === groupId ? null : groupId;
    },

    onFilterToggle(filter, executeSearch) {
      this.$store.commit('setFilterValue', { filter, value: !filter.selected });
      this.$store.dispatch('executeSearch');
    },

    handleOutsideClick(event) {
      if (!this.$el || !this.openGroupId) return;
      const openEl = this.$el.querySelector(
        `.schedule-controls__filter[data-filter-id="${this.openGroupId}"]`
      );
      if (openEl && !openEl.contains(event.target)) {
        this.openGroupId = null;
      }
    },

    onDrawerKeydown(e) {
      if (e.key === 'Escape' && this.drawerOpen) this.drawerOpen = false;
    },

    sortValue(sort) {
      if (!sort) return 'startTime_asc';
      if (typeof sort === 'object') {
        const field = sort.fieldName || 'startTime';
        const mode = sort.sortMode || 'asc';
        return `${field}_${mode}`;
      }
      return sort;
    },

    sortOptions(results) {
      const SCHEDULE_SORT_KEYS = [
        'startTime_asc',
        'title_normalized_asc',
        'title_normalized_desc',
        'session_format_normalized_asc',
      ];
      const fallback = [
        { fieldName: 'startTime',                 sortMode: 'asc',  displayName: 'time' },
        { fieldName: 'title_normalized',          sortMode: 'asc',  displayName: 'a-z' },
        { fieldName: 'title_normalized',          sortMode: 'desc', displayName: 'z-a' },
        { fieldName: 'session_format_normalized', sortMode: 'asc',  displayName: 'session type' },
      ];
      if (results && results.sortOptions && results.sortOptions.length) {
        const filtered = results.sortOptions.filter(
          o => SCHEDULE_SORT_KEYS.includes(`${o.fieldName}_${o.sortMode}`)
        );
        return filtered.length ? filtered : fallback;
      }
      return fallback;
    },

    sortDisplayName(option) {
      if (!option) return '';
      const labels = {
        'startTime_asc':                 'Sort by time',
        'title_normalized_asc':          'Sort by a-z',
        'title_normalized_desc':         'Sort by z-a',
        'session_format_normalized_asc': 'Sort by session type',
      };
      return labels[`${option.fieldName}_${option.sortMode}`] || option.displayName || '';
    },

    onSortChange(event, results) {
      const value = event.target.value;
      const options = this.sortOptions(results);
      const selected = options.find(o => `${o.fieldName}_${o.sortMode}` === value);
      if (selected) {
        this.$store.dispatch('changeSort', selected);
      }
    },
  },
};
